export default __webpack_public_path__ + "static/media/desktop-yield.041dbd38.png";